import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c1820f9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_shopping [ JS_blueCartButton JS_header_toggle_interactive ]" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["cartcount_indicator", _ctx.isCartFilled ? 'active' : ''])
        }, null, 2),
        _hoisted_2
    ]));
}
